var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{attrs:{"data":_vm.groups,"node-key":"uuid","default-expand-all":"","expand-on-click-node":false},on:{"node-click":_vm.nodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[_c('span',{class:{active: data.uuid ===_vm.activeUuid}},[_vm._v(_vm._s(data.name))])])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }